import { GatsbyImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';

import ContentfulImage from '../../Common/ContentfulImage';
import RichTextConverter from '../../Common/RichText/RichTextConverter';
import GatedForm, { propTypes } from './GatedForm';
import * as styles from './HeadingWithForm.module.scss';

const HeadingWithForm = ({
  title,
  superText,
  lede,
  excerpt,
  formData,
  headingFontColor,
  backgroundImageUrl,
  headingImage,
  availableForAll,
  onSuccess,
  id,
  trackingPixelUrl,
  downloadCtaLabel,
  uniqueTrackingPixel,
}) => {
  const fontClass = headingFontColor === 'Dark' ? '' : styles.lightFont;
  const imageData = formData?.heroImage?.gatsbyImageData;
  const img = formData?.heroImage?.file?.url;
  let image;
  if (imageData) {
    image = (
      <GatsbyImage
        image={formData?.heroImage?.gatsbyImageData}
        className={styles.heroImage}
        imgStyle={{ objectFit: 'contain' }}
        alt={title}
      />
    );
  } else if (img) {
    image = <img src={img} className={styles.heroImage} loading="lazy" alt={title} />;
  }

  return (
    <div className={styles.container} id={id} data-analytics-section={'heading-with-form'}>
      <div
        className={styles.bg}
        style={{
          backgroundImage: `url("${backgroundImageUrl}")`,
        }}
      />
      <div
        className={[styles.heading, fontClass].join(' ')}
        data-analytics-component={'heading-copy'}
        data-analytics-id={title}
      >
        {headingImage && <ContentfulImage imageFragment={headingImage} />}
        {!headingImage && (
          <>
            {superText && <span className={styles.superText}>{superText}</span>}
            <h1 className={styles.gatedH1}>{title}</h1>
            {lede && <p>{lede}</p>}
          </>
        )}
      </div>
      {!availableForAll && (
        <div className={styles.form}>
          <GatedForm
            contentIsDownloadable={formData.contentIsDownloadable}
            successCopy={formData.successCopy}
            fileUrl={formData.fileUrl}
            heroImage={formData.heroImage}
            useEmbeddedForm={true}
            slug={formData.slug}
            dynamicForm={formData.dynamicForm}
            title={title}
            onSuccess={onSuccess}
            trackingPixelUrl={trackingPixelUrl}
            uniqueTrackingPixel={uniqueTrackingPixel}
            downloadCtaLabel={downloadCtaLabel}
            marketoFormId={formData.marketoFormId}
          />
        </div>
      )}
      {availableForAll && formData.heroImage && image}
      <div className={[styles.excerpt, availableForAll ? styles.expand : ''].join(' ')}>
        <RichTextConverter copy={excerpt} />
      </div>
    </div>
  );
};

HeadingWithForm.propTypes = {
  title: PropTypes.string.isRequired,
  superText: PropTypes.string,
  lede: PropTypes.string,
  headingFontColor: PropTypes.oneOf(['Dark', 'Light']),
  backgroundImageUrl: PropTypes.string,
  formData: PropTypes.shape({ ...propTypes }),
};

export default HeadingWithForm;
